import * as R from 'ramda';


const initialState = {
  systemParsers: [],
  companyParsers: [],
  parsersInEdit: [],
  parsersBeforeSave: [],
  promptStrategy: '',
  promptStrategyBeforeSave: '',
  rules: [],
  // forwardHistory: [],
  // backHistory: [],
};

// Helper function to map rules to parsers
const mapRulesToParsers = (parsers, rules) => {
  return parsers.map(parser => ({
    ...parser,
    promptSections: parser.promptSections?.map(section => ({
      ...section,
      rules: R.pathOr([], ['ruleIds'], section).map(ruleId => rules.find(r => r.id === ruleId)).filter(Boolean)
    })) || []
  }));
};

// Helper function to update rules in a section
const updateSectionRules = (section, rule) => {
  if (rule.toDelete) {
    return {
      ...section,
      rules: section.rules.filter(r => r.id !== rule.id)
    };
  }
  
  if (rule.toCreate) {
    return {
      ...section,
      rules: [...section.rules, rule]
    };
  }
  
  if (rule.toUpdate) {
    return {
      ...section,
      rules: section.rules.map(r => r.id === rule.id ? rule : r)
    };
  }
  
  return {
    ...section,
    rules: [...section.rules, rule],
  };
};

export default function extractionSettings(state = initialState, { type, payload, args }) {
  switch(type) {
    case 'genAI_extractionSettings_getLLMParserInJson':
      if (payload) {
        return {
          ...state,
          ...payload,
        };
      }
      return state;
    case 'genAI_extractionSettings_loadLLMParserForNewStrategy_SUCCESS': {
      // this call is made when user toggle the strategy dropdown
      // the rules should have already been loaded on page load
      const partnerId = args[0].partnerId;
      const mappedParsers = mapRulesToParsers(partnerId ? payload.partnerParsers : payload.companyParsers, state.rules)
      return {
        ...state,
        ...payload,
        parsersInEdit: mappedParsers,
        parsersBeforeSave: mappedParsers,
      }
    }
    case 'genAI_extractionSettings_getLLMParserInJson_SUCCESS': {
      const partnerId = args[0].partnerId;
      if (state.rules.length > 0) {
        // when rules exist, we need to map the rules to the parsers
        const mappedParsers = mapRulesToParsers(partnerId ? payload.partnerParsers : payload.companyParsers, state.rules)
        return {
          ...state,
          ...payload,
          promptStrategyBeforeSave: payload.promptStrategy,
          parsersInEdit: mappedParsers,
          parsersBeforeSave: mappedParsers,
        };
      }
      return {
        ...state,
        ...payload,
        promptStrategyBeforeSave: payload.promptStrategy,
        parsersInEdit: partnerId ? payload.partnerParsers : payload.companyParsers,
        parsersBeforeSave: partnerId ? payload.partnerParsers : payload.companyParsers,
      };
    }
    case 'genAI_extractionSettings_getRules_SUCCESS':
      // When we get rules, map them to parsersInEdit
      return {
        ...state,
        rules: payload.rules,
        parsersInEdit: mapRulesToParsers(state.parsersInEdit, payload.rules),
        parsersBeforeSave: mapRulesToParsers(state.parsersBeforeSave, payload.rules),
      };
    case 'genAI_extractionSettings_updateParser': {
      return {
        ...state,
        parsersInEdit: R.assocPath([payload.parserIndex, 'schema'], payload.schema, state.parsersInEdit),
      };
    }
    case 'genAI_extractionSettings_updateRuleContent': {
      const { parserIndex, sectionKey, rule } = payload;
      return {
        ...state,
        parsersInEdit: state.parsersInEdit.map((parser, index) => {
          if (index !== parserIndex) return parser;
          
          return {
            ...parser,
            promptSections: parser.promptSections.map(section => 
              section.sectionKey === sectionKey 
                ? updateSectionRules(section, rule)
                : section
            )
          };
        })
      };
    }
    case 'genAI_extractionSettings_updatePromptStrategy':
      return {
        ...state,
        promptStrategy: payload.newStrategy,
      };
    case 'genAI_extractionSettings_saveParsersAndRule_SUCCESS':
      return {
        ...state,
        parsersBeforeSave: state.parsersInEdit,
      };
    case 'genAI_extractionSettings_copyToPartner_SUCCESS':
      return {
        ...state,
        severity: 'success',
        text: "Copied to partner successfully",
      }
    case 'genAI_extractionSettings_updateProps':
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
